import { render, staticRenderFns } from "./homeUp.vue?vue&type=template&id=62ea39b2&scoped=true&"
import script from "./homeUp.vue?vue&type=script&lang=js&"
export * from "./homeUp.vue?vue&type=script&lang=js&"
import style0 from "./homeUp.vue?vue&type=style&index=0&id=62ea39b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ea39b2",
  null
  
)

export default component.exports